import React from "react";
// import { useNavigate } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";


const Hero = () => {
  // const navigate = useNavigate();
  // const handleShopNow = () => {
  //   console.log("Navigating to /shopnow");
  //   navigate("/shopnow");
  // };

  return (
    <section className="relative bg-green-50 h-[100vh] lg:h-[100vh] flex items-center justify-center text-center lg:text-left overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url("https://images.unsplash.com/photo-1547489432-cf93fa6c71ee?q=80&w=3870&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D")`,
        }}
      ></div>

      {/* Content Container */}
      <div className="relative z-10 container mx-auto px-4 flex flex-col gap-8 lg:flex-row items-center">
        {/* Text Section */}
        <div className="w-full lg:w-1/2">
          <h1 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            {/* Typing effect on larger screens */}
            <span className="hidden lg:inline">
              <TypeAnimation
                sequence={[
                  "Precision medicine made simpler for you.",
                  2000,
                  "Get expert support and advice anytime.",
                  2000,
                  "Your trusted online pharmacy.",
                  2000,
                ]}
                wrapper="span"
                speed={50}
                repeat={Infinity}
                className="text-white"
              />
            </span>
            {/* Word-by-word animation on smaller screens */}
            <span className="lg:hidden">
              <TypeAnimation
                sequence={[
                  "Precision",
                  500,
                  "medicine",
                  500,
                  "made",
                  500,
                  "simpler",
                  500,
                  "for",
                  500,
                  "you.",
                ]}
                wrapper="span"
                speed={50}
                repeat={Infinity}
                className="text-white"
              />
            </span>
          </h1>
          <p className="text-lg lg:text-2xl mb-6 text-white">
            Get your prescriptions filled and delivered right to your door, with
            expert support and advice.
          </p>
          {/* <button
            onClick={handleShopNow}
            className="bg-green-600 text-white py-3 px-6 lg:px-8 lg:py-4 text-lg lg:text-xl rounded-lg shadow hover:bg-green-700"
          >
            Shop Now
          </button> */}
        </div>
      </div>
    </section>
  );
};

export default Hero;
